export default {
  formActions: {
    addPlaceInput: 'Punkt hinzufügen',
    clearRoute: 'Route löschen',
    reverseRoute: 'Route umkehren',
    roundTrip: 'Rundweg',
    toggleRoundTrip: 'Rundweg an/aus'
  }
}
